// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"830":"7c8aef2c","905":"f0b328a4"}[chunkId] + ".css";
};